module.exports = __webpack_public_path__ + "static/media/disabled-photos.f279c0ab.svg";